import React from 'react';

const LoadingUnCheckIcon: React.FC = () => (
  <svg width="42" height="43" viewBox="0 0 42 43" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.66916 12.4369C0.871775 12.9685 0.392822 13.8634 0.392822 14.8217V40.0482C0.392822 41.6312 1.67608 42.9145 3.25906 42.9145H39.004C40.5869 42.9145 41.8702 41.6312 41.8702 40.0482V14.8217C41.8702 13.8634 41.3913 12.9685 40.5939 12.4369L23.0394 0.733911C21.8841 -0.0363037 20.379 -0.0363038 19.2236 0.733911L1.66916 12.4369ZM21.1313 33.0364C24.9492 33.0364 28.0442 29.9414 28.0442 26.1235C28.0442 22.3056 24.9492 19.2106 21.1313 19.2106C17.3134 19.2106 14.2184 22.3056 14.2184 26.1235C14.2184 29.9414 17.3134 33.0364 21.1313 33.0364Z"
      fill="#EBEBEB"
    />
  </svg>
);

export default LoadingUnCheckIcon;
